import {  useState,} from "react";
import { Menu, } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";
import {
  THEMES,
} from "cdk-radial";
import styled from 'styled-components';
import "../v2/header/menu.css";
import {
  PrimaryButton,
} from 'cdk-radial';
import LogoutConfirmDialog from '../v2/header/LogoutConfirmDialog';
import { APP_ENV } from '../constants';


export const generateTooltipProps = (
  iconName: string,
  displayName: string
) => ({
  id: `header-tooltip-${iconName}`,
  text: displayName,
  theme: THEMES.LIGHT,
  styles: { zIndex: 1002, display: window.innerWidth < 501 && "none" },
});

export const logoutMapping = () => {
  if (APP_ENV === 'us-dit') {
    return [
      "https://app-dms-root-app.app-dev.connectcdk.com/sso/logout"
    ];
  }
  else if (APP_ENV === 'us-stage') {
    return [
      "https://app-dms-root-app.app-dev.connectcdk.com/sso/logout"
    ];
  }
  else if (APP_ENV === 'us-perf') {
    return [
      "https://app-dms-root-app.app-stage.connectcdk.com/sso/logout"
    ];
  }
  else if (APP_ENV === 'us-prod') {
    return [
      "https://driveworkflowmenu.connectcdk.com/sso/logout"
    ];
  }else {
    return [
      "https://app-dms-root-app.app-dev.connectcdk.com/sso/logout"
    ];
  }
}

export const StyledMenu = styled(Menu)`
  background-color: #222 !important;`

export const ERHeaderMenu = ({ setLogout }: 
    {setLogout: any}) => {
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);
  const logoutUrls = logoutMapping();

   const signOutUnify = async () => {
    setLogout("INPROGRESS");
    setShowLogoutDialog(false);
    try {
      const iFrame = document.getElementById('unify-er-frame-main') as HTMLIFrameElement;
      if (iFrame) {
        for (let i = 0; i < logoutUrls.length; i++) {
          const url = logoutUrls[i];
          console.log(`[${i + 1}/${logoutUrls.length}] Setting iframe src to: ${url}`);
          setTimeout(() => (iFrame.contentWindow!.location.href = url+"?d="+Date.now()), 0);
          await new Promise(resolve => setTimeout(resolve, 5000));
        }
      } else {
        console.error('ERROR: iframe not found with id: unify-er-frame-main');
      }
      setLogout("DONE");
    } catch (error) {
      console.error('Error during logout:', error);
      setLogout("DONE");
    }

  };

  const logout =  () => {
   setShowLogoutDialog(true);
  }

  return (
    <>
      <PrimaryButton
            style={{border:"none"}}
            onClick={() => logout()}
            size="standard"
            text={"Sign Out"} />

      <LogoutConfirmDialog
            isOpen={showLogoutDialog}
            data-testid="logout_dialog"     
            onLogout={async () => { await signOutUnify() }}
            onCancel={() => {setShowLogoutDialog(false)}}
      />
    </>
  );
};

